module.exports = __webpack_public_path__ + "img/roque.ad1cf2b0.png";